module.exports = __webpack_public_path__ + "img/bg.495088fc.png";